export default __webpack_public_path__ + "static/media/safari_settings_ios_17.d4c45d44.png";